import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import OTPComponent from './OTPComponent';
import { login, generateLoginOTP } from '../actions/signinAction';
import { hideModal } from '../../actions/modal.js';
import { parseSearch } from '../../modules/ajio-util/query';
import { validateMobile, validateEmail } from '../../utils/inputValidator';
import { createRedirectUri } from '../../utils/redirectUtil';

class AccCheckSocialUser extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      errorMsg: '',
      mobNum: '',
      otp: '',
      showTimer: true,
      userData: ''
    };
  }

  componentDidMount() {
    let { emailId = '', mobileNumber = '' } = this.props;
    const userCred = this.props.userCred || mobileNumber || emailId;
    let userData;
    if (validateMobile(userCred)) {
      userData = { mobileNumber: userCred };
    } else if (validateEmail(userCred)) {
      userData = { emailId: userCred };
    }
    this.props.generateLoginOTP(userData);
    this.setState({
      userData
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { queryString = '', mobileNumber = '', emailId = '' } = this.props || {};
    const userCred = this.props.userCred || mobileNumber || emailId;
    var signInObj = {};
    signInObj = {
      username: userCred,
      otp: this.state.otp,
      device: this.props.viewSiteAs
    };
    const queryObj = parseSearch(queryString);
    if (this.state.otp !== '') {
      this.props.login(signInObj, () => {
        if (this.props.validUser) {
          let redirectURI = createRedirectUri(this.props.queryString);
          redirectURI = queryObj.referrer ? redirectURI + queryObj.referrer : redirectURI;
          if (this.props.viewSiteAs == 'desktop') {
            let { location: { search = '', pathname: source = '' } = {} } = this.props;
            if (source == '/login') {
              window.location = redirectURI;
            } else {
              // close modal
              this.props.hideModal('sign-in-up');
              let { location: { href = '' } = {} } = window;
              if (!href.includes('/cart')) {
                window.location.reload();
              }
            }
          } else {
            const lastVisit = window.location.href;
            if (lastVisit.includes('?referrer')) {
              let referrerUrl = lastVisit.split('=').slice(1);
              referrerUrl = referrerUrl.join('=');
              try {
                const parsedUrl = new URL(referrerUrl, window.location.origin);
                if (parsedUrl.origin === window.location.origin) {
                  window.location = parsedUrl.href;
                } else {
                  window.location = redirectURI;
                }
              } catch (e) {
                window.location = redirectURI;
              }
            } else {
              window.location = redirectURI;
            }
          }
        }
        if (this.props.statusCode == 400) {
          let erMsg = 'Invalid OTP';
          if (this.props.errMsg.includes('exceeded')) {
            erMsg = 'You have exceeded maximum OTP attempts, Please try again after some time.';
          }
          if (this.props.errMsg.includes('locked')) {
            erMsg = this.props.errMsg;
          }
          this.setState({
            errorMsg: erMsg,
            showTimer: false
          });
        } else {
          this.setState({ errorMsg: '' });
        }
      });
    } else {
      this.setState({
        errorMsg: 'Please enter a valid OTP',
        showTimer: true
      });
    }
  }

  getOTPforAuthCB = otpValue => {
    this.setState({ otp: otpValue });
  };

  resendOTPforAuthCB = () => {
    let { userCred = '' } = this.props;
    ga('send', {
      eventCategory: 'Login',
      eventAction: 'Sign in with OTP',
      eventLabel: 'Resend OTP'
    });
    this.props.generateLoginOTP(this.state.userData);
    this.setState({
      errorMsg: '',
      showTimer: true
    });
  };

  render() {
    const { viewSiteAs = '', twoFactorAuth = false } = this.props;
    return (
      <div>
        <form
          className="login-form"
          onSubmit={this.handleSubmit}
          data-ga-event-category=""
          data-ga-event-action=""
          data-ga-event-label=""
        >
          <h1> Glad you&#39;re back! </h1>

          {twoFactorAuth ? (
            <p className="login-form-inputs">
              {`Please enter OTP sent to ${this.props.emailId} or ${this.props.maskedMobileNumber}`}
            </p>
          ) : (
            <>
              <div className="login-form-inputs">
                A Password has not been set for this account. Please enter OTP sent to
              </div>
              <div> {this.props.emailId} </div>
              <div> {this.props.maskedMobileNumber} </div>
            </>
          )}
          <OTPComponent
            getOTP={this.getOTPforAuthCB}
            resendOTP={this.resendOTPforAuthCB}
            viewSiteAs={viewSiteAs}
            showTimer={this.state.showTimer}
            errorMsg={this.state.errorMsg}
          />

          <div>
            <input type="submit" className="login-form-inputs login-btn" value="START SHOPPING" />
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    login: (formData, callback) => {
      dispatch(login(formData, callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    generateLoginOTP: (mobile, callbackOtp) => {
      dispatch(generateLoginOTP(mobile, callbackOtp));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const { signInReducer = {}, httpError = {} } = state;
  const {
    validUser = false,
    maskedMobileNumber = '',
    maskedEmailId = '',
    mobileNumber = '',
    emailId = ''
  } = signInReducer;
  const { error = {} } = httpError;
  const { statusCode = '', message = '' } = error;
  return {
    httpError,
    validUser,
    statusCode,
    mobileNumber,
    maskedEmailId,
    maskedMobileNumber,
    emailId,
    mobileNumber,
    errMsg: message
  };
};

export default AccCheckSocialUser = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AccCheckSocialUser)
);
